import { Navigate, useLocation } from "react-router-dom";
import ConfigAssistent from "../pages/configAssistent";
import { getCookie } from "../utils";
import MainLayout from "../layout/mainLayout";
import Dashboard from "../pages/dashboard";
import NotFound from "../pages/notFound";
import Desenvolvimento from "../pages/desenvolvimento";
import ConversationChat from "../pages/conversationChat";
import GestaoUsuarios from "../pages/gestaoUsuarios";
import Notificacoes from "../pages/notifications";
import ConfigPromptJson from "../pages/configPromptJson";

const Private = ({ children }) => {
    const location = useLocation();
    const logado = getCookie("authToken");

    if (!logado) return <Navigate to="/login" />
    else if (logado && location.location?.inclues("login")) return <Navigate to="/" />

    if (logado) {
        return children;
    }

    return <Navigate to={"/login"} />;
}

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: (
                <Private>
                    <Dashboard />
                </Private>
            ),
        },
        {
            path: '/*',
            element: (
                <Private>
                    <Desenvolvimento />
                </Private>
            ),
        },
        {
            path: '/dashboard',
            element: (
                <Private>
                    <Dashboard />
                </Private>
            ),
        },
        {
            path: '/configuracao-agente',
            element: (
                <Private>
                    <ConfigAssistent />
                </Private>
            ),
        },
        {
            path: '/conversation-chat',
            element: (
                <Private>
                    <ConversationChat />
                </Private>
            ),
        },
        {
            path: '/interacoes-usuarios',
            element: (
                <Private>
                    <GestaoUsuarios />
                </Private>
            ),
        },
        {
            path: '/notificacoes',
            element: (
                <Private>
                    <Notificacoes />
                </Private>
            ),
        },
        {
            path: '/prompt-config',
            element: (
                <Private>
                    <ConfigPromptJson />
                </Private>
            ),
        }
    ]
};

export default MainRoutes;